import Vue from 'vue'
import Vuex from 'vuex'
import preferences from './modules/preferences/index.js'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
  },
  getters: {},
  mutations: {
  },
  actions: {
  },
  modules: {
    preferences: preferences.module
  },
  plugins: [preferences.store]
})

export default store
